import * as React from "react";

import primaryColour from "../../constants";

function SvgAbsStop(props: React.SVGProps<SVGSVGElement>) {
  const { fill = primaryColour } = props;
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.3432 6.48523L20.2375 6.59091C21.446 8.34582 22.0302 10.401 21.9902 12.4463C21.874 15.0931 20.7289 17.4727 18.9451 19.1949L17.9341 18.184C20.7687 15.3494 21.1517 10.9916 19.083 7.74538L18.0403 8.78806C18.27 9.06505 18.4081 9.42075 18.4081 9.80869V10.5306H17.2081V9.80869C17.2081 9.75313 17.1967 9.70021 17.1763 9.65212L16.0391 10.7893V11.2525C16.0391 11.4735 16.2182 11.6525 16.4391 11.6525L16.8081 11.6527C17.6917 11.6527 18.4081 12.369 18.4081 13.2527V14.6965C18.4081 15.5802 17.6917 16.2965 16.8081 16.2965H16.4391C15.5555 16.2965 14.8391 15.5802 14.8391 14.6965V13.9746H16.0391V14.6965C16.0391 14.9175 16.2182 15.0965 16.4391 15.0965H16.8081C17.029 15.0965 17.2081 14.9175 17.2081 14.6965V13.2527C17.2081 13.0318 17.029 12.8527 16.8081 12.8527L16.4391 12.8525C15.7732 12.8525 15.2023 12.4457 14.9614 11.867L14.0654 12.763C14.115 12.9173 14.1417 13.0819 14.1417 13.2527V14.6965C14.1417 15.5802 13.4254 16.2965 12.5417 16.2965H10.5728V16.2556L6.48515 20.3432C5.92415 19.9717 5.40282 19.545 4.92884 19.0711L19.071 4.92896C19.545 5.40292 19.9716 5.92425 20.3432 6.48523ZM11.7728 15.0556L12.9417 13.8867V14.6965C12.9417 14.9175 12.7626 15.0965 12.5417 15.0965H11.7728V15.0556Z"
        fill={fill}
      />
      <path
        d="M3.65672 17.5148L4.72816 16.4433C2.87481 13.2342 3.32066 9.0606 6.06572 6.31554L4.93435 5.18417C2.93499 7.18353 1.96003 9.81938 2.00948 12.4395C2.09038 14.3104 2.68536 16.0481 3.65672 17.5148Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.19264 11.9788L5.78218 15.3893L6.92571 8.25606H8.58485L9.19264 11.9788ZM7.75852 10.6421L8.11303 12.8135H7.41043L7.75852 10.6421Z"
        fill={fill}
      />
      <path
        d="M12.9182 8.25325L10.5728 10.5987V8.20869H12.5417C12.6714 8.20869 12.7975 8.22412 12.9182 8.25325Z"
        fill={fill}
      />
    </svg>
  );
}

export default SvgAbsStop;
